import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import type { LocalDate } from "@js-joda/core";
import type { EnumDayOfWeek } from "@/app/services/generated/enums/enumDayOfWeek.generated";
import { doesDateMatchRepeatSchedule } from "@/business_logic/distribution/distributionUtils";
import type { Maybe } from "@/components/utils/typeHelpers";

export function despatchDateHighlighter(
  date: LocalDate,
  despatchDays: readonly EnumDayOfWeek[],
  leadTimeDays: number,
  repeatWeeks: number,
  repeatStartDate: Maybe<LocalDate>,
  primaryEventColour: string = "brand02",
  warningEventColour: string = "warningMedium"
) {
  const today = tenantService.today;
  // Check if values are in the future or today and the day of the week matches distribution Object
  if (
    !date.isBefore(today) &&
    doesDateMatchRepeatSchedule(
      date,
      despatchDays,
      repeatWeeks,
      repeatStartDate
    )
  ) {
    // If the value is within the lead time, Show but highlight with warning color
    if (leadTimeDays && date.isBefore(today.plusDays(leadTimeDays))) {
      return warningEventColour;
    }
    return primaryEventColour;
  }
  return "";
}
